import React from 'react';
import { EnPowerLogoText, EnPowerWordmarkInline } from '../EnPowerLogo';
import { DraggableElement } from '../DraggableElement';

const SOLAR_IMAGE = '/solar-farm-bg.jpg';

const DATA = {
  kundenname: 'Mustermann Agrar GmbH',
  kundenadresse: 'Feldweg 7, 34576 Musterregion, Hessen',
  angebotsnummer: 'FF-2025-0118',
  kundennummer: 'KD-2118',
  datum: '15. Januar 2025',
  gueltig_bis: '15. März 2025',
};

export const CoverPageStatic = ({
  data = {},
  editMode = false,
  showMarkers = true,
  selectedElements = [],
  elementPositions = {},
  onSelectElement,
  onPositionChange,
}) => {
  const offerData = { ...DATA, ...data };
  const dragProps = {
    editMode,
    showMarkers,
    selectedElements,
    elementPositions,
    onSelectElement,
    onPositionChange,
    dragAxis: 'y',
  };

  return (
    <div className="a4-page" data-testid="cover-page" style={{ background: '#0E1E3C', overflow: 'hidden' }}>
      <DraggableElement id="FF-S1-Deckblatt" {...dragProps} initialStyle={{ width: '100%', height: '100%' }}>
        {/* Hero image */}
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '52%', overflow: 'hidden' }}>
          <img
            src={SOLAR_IMAGE}
            alt="Freiflächen-Photovoltaikanlage aus der Luft"
            style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center center', display: 'block', filter: 'brightness(0.75) saturate(0.9)' }}
          />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(14,30,60,0.22) 0%, transparent 25%, rgba(14,30,60,0.65) 72%, #0E1E3C 100%)', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '96px', background: 'linear-gradient(to bottom, #0E1E3C 0%, rgba(14,30,60,0.58) 64px, transparent 100%)', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', top: 0, left: 0, width: '4px', height: '100%', background: 'linear-gradient(to bottom, #E07000, rgba(224,112,0,0.2))' }} />
        </div>

        {/* Navy bottom half */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '52%', background: 'linear-gradient(160deg, #122A5C 0%, #0E1E3C 100%)' }} />

        {/* Content */}
        <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', padding: '32px 48px' }}>
        {/* Top bar: EN:POWER x ILOS */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <EnPowerLogoText size="lg" variant="light" />
            <span style={{ fontFamily: 'Outfit, sans-serif', fontSize: '18px', fontWeight: 300, color: 'rgba(255,255,255,0.4)' }}>&times;</span>
            <span style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 700, fontSize: '32px', lineHeight: '32px', color: 'white', letterSpacing: '-0.02em' }}>ILOS</span>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '4px', padding: '5px 14px', fontFamily: 'Manrope, sans-serif', fontSize: '8.5px', fontWeight: 700, color: 'rgba(255,255,255,0.8)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Indikationsangebot</div>
        </div>

        <div style={{ flex: '0 0 30%' }} />

        <div style={{ flexShrink: 0 }}>
          <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '9px', fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#E07000', marginBottom: '12px' }}>Freiflächen-Photovoltaik &bull; Flächenverpachtung</p>
          <h1 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: '64px', color: 'white', letterSpacing: '-0.04em', lineHeight: 0.9, marginBottom: '18px', textShadow: '0 2px 24px rgba(0,0,0,0.5)' }}>IHR<br />ANGEBOT</h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '52px', height: '3px', background: '#E07000', borderRadius: '2px', flexShrink: 0 }} />
            <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '13.5px', fontWeight: 500, color: 'rgba(255,255,255,0.75)', margin: 0 }}>
              Exklusiv erstellt für <span style={{ color: 'white', fontWeight: 700 }}>{offerData.kundenname}</span>
            </p>
          </div>
        </div>

        {/* Metadata */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', paddingBottom: '36px' }}>
          {/* Partnership badge */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 14px', background: 'rgba(224,112,0,0.12)', border: '1px solid rgba(224,112,0,0.25)', borderRadius: '6px' }}>
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#E07000' }} />
              <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '8.5px', fontWeight: 700, color: '#E07000', letterSpacing: '0.06em', textTransform: 'uppercase' }}>Gemeinschaftsprojekt EN:POWER &times; ILOS</span>
            </div>
          </div>

          {/* Project address */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', padding: '8px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '7px' }}>
            <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '8.5px', fontWeight: 700, color: 'rgba(255,255,255,0.72)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Projektstandort</span>
            <div style={{ width: '1px', height: '12px', background: 'rgba(255,255,255,0.15)' }} />
            <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '10.5px', fontWeight: 500, color: 'rgba(255,255,255,0.92)' }}>{offerData.kundenadresse}</span>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', borderTop: '1px solid rgba(255,255,255,0.08)', borderBottom: '1px solid rgba(255,255,255,0.08)', paddingTop: '18px', paddingBottom: '18px' }}>
            {[
              { label: 'Angebots-Nr.', value: offerData.angebotsnummer },
              { label: 'Kunden-Nr.', value: offerData.kundennummer },
              { label: 'Datum', value: offerData.datum },
              { label: 'Gültig bis', value: offerData.gueltig_bis, highlight: true },
            ].map((item, i) => (
              <div key={i} style={{ padding: '0 16px', borderRight: i < 3 ? '1px solid rgba(255,255,255,0.08)' : 'none' }}>
                <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '8px', fontWeight: 700, color: 'rgba(255,255,255,0.35)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '5px' }}>{item.label}</p>
                <p style={{ fontFamily: 'Outfit, sans-serif', fontSize: '13px', fontWeight: 600, color: item.highlight ? '#E07000' : 'white', letterSpacing: '-0.01em', margin: 0 }}>{item.value}</p>
              </div>
            ))}
          </div>

          <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '8px', color: 'rgba(255,255,255,0.25)', letterSpacing: '0.03em', marginTop: '14px' }}>
            Dieses Angebot ist vertraulich und wurde ausschließlich für den genannten Empfänger erstellt. &middot;{' '}
            <EnPowerWordmarkInline enColor="#FFFFFF" fontSize="7px" /> &times; ILOS Energy &middot; info@enpower.de
          </p>
        </div>
        </div>
      </DraggableElement>
    </div>
  );
};
